// extracted by mini-css-extract-plugin
module.exports = {"clickableArrow":"ClickableArrow_clickableArrow__6Fy0e","disabled":"ClickableArrow_disabled__afmcG"};